import { styled } from 'styled-components';
import { device, hexToRGB, typography } from '@/styles/helpers';
import { ScTermsButton } from '../../../DiceRollPage/components/PrizeBlock/styled';
import { ScScratchActionButton } from '../ScratchActionButton/styled';
import { ScScratchBonusTerms } from '../ScratchBonusTerms/styled';

export const ScScratchTicketSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;

  & > .ticket-tabs {
    width: min(544px, 100%);
    margin-inline: auto;

    & .premium-tab {
      background: linear-gradient(
        270deg,
        #ffd500 0%,
        #ffad01 50%,
        #bd5d0d 100%
      );
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }

  & > .description {
    max-width: 655px;
    ${typography['body2regular']}
    text-align: center;
    color: ${({ theme }) => theme.whiteColor};
    margin-block: 8px 4px;
    margin-inline: auto;
    white-space: pre-line;

    @media (${device.mobile}) {
      margin-block: 0 32px;
    }
  }

  & > ${ScScratchActionButton} {
    margin-top: 16px;
    @media (${device.mobile}) {
      margin-top: 8px;
    }
  }

  & ${ScScratchBonusTerms} {
    & .content {
      width: min(480px, 100%);
      margin-inline: auto;

      @media (${device.mobile}) {
        & > p {
          padding-inline: 6px;
          background-color: ${({ theme }) => hexToRGB(theme.blackColor, 0.75)};

          &:first-child {
            padding-top: 6px;
            border-radius: 8px 8px 0 0;
          }

          &:last-child {
            padding-bottom: 6px;
            border-radius: 0 0 8px 8px;
          }
        }
      }
    }
  }

  & ${ScTermsButton} {
    justify-content: center;
  }

  & > .scratch-daily-limit {
    display: flex;
    align-items: center;
    gap: 4px;
    ${typography['body1regular']}

    @media (${device.mobile}) {
      margin-top: -6px;
      ${typography['body2regular']}
    }

    & > span:first-child {
      font-weight: 700;
    }
  }
`;
